<div class="chart-container" [ngClass]="{'dark-mode': isDarkMode}">
  <div class="header-controls">
    <!-- <h3 class="chart-title">Sensor Data Analysis</h3> -->
    <div [ngSwitch]="graphType">
      <h3 *ngSwitchCase="0" class="chart-subtitle">Vibration - Acceleration Trend (m/sec²)</h3>
      <h3 *ngSwitchCase="1" class="chart-subtitle">Vibration - Velocity Trend (mm/sec)</h3>
      <h3 *ngSwitchCase="2" class="chart-subtitle">Machine Acoustics (dB)</h3>
      <h3 *ngSwitchCase="3" class="chart-subtitle">Audible (dB-A)</h3>
      <h3 *ngSwitchCase="4" class="chart-subtitle">Temperature Trend(°C)</h3>
      <h3 *ngSwitchDefault class="chart-subtitle">Sensor Data Analysis</h3>
    </div>
    <!-- <h3 class="chart-subtitle">Sensor Data Analysis</h3> -->
    <div class="mode-toggle">
      <button class="mode-button" (click)="toggleDarkMode()">
        <span *ngIf="!isDarkMode" class="mode-icon">☀️</span>
        <span *ngIf="isDarkMode" class="mode-icon">🌙</span>
        <!-- <span>{{ isDarkMode ? 'Light Mode' : 'Dark Mode' }}</span> -->
      </button>
    </div>
  </div>

  <div class="filter-panel">
    <!-- Axis filter dropdown -->
    <div class="filter-section axis-dropdown">
      <button class="dropdown-toggle modern-btn" (click)="toggleDropdown('axis')">
        <span>Axes</span>
        <span class="selected-count">{{ (showXAxis ? 1 : 0) + (showYAxis ? 1 : 0) + (showZAxis ? 1 : 0) }}</span>
        <span class="dropdown-icon" [ngClass]="{'open': isAxisDropdownOpen}"></span>
      </button>
      <div class="dropdown-menu" [ngClass]="{'show': isAxisDropdownOpen}">
        <div class="dropdown-header">
          <!-- <h5 class="chart-subtitle">Select Axis Display</h5> -->
        </div>
        <div class="mac-address-list axis-list">
          <div class="mac-item">
            <label class="checkbox-container">
              <input type="checkbox" [checked]="showXAxis" (change)="toggleAxis('X')">
              <span class="checkmark"></span>
              <span class="mac-label">{{tempLabelX || 'X-Axis'}}</span>
            </label>
          </div>
          <div class="mac-item" *ngIf="graphType !== 2 && graphType !== 3">
            <label class="checkbox-container">
              <input type="checkbox" [checked]="showYAxis" (change)="toggleAxis('Y')">
              <span class="checkmark"></span>
              <span class="mac-label">{{tempLabelY || 'Y-Axis'}}</span>
            </label>
          </div>

          <div class="mac-item" *ngIf="graphType !== 2 && graphType !== 3">
            <label class="checkbox-container">
              <input type="checkbox" [checked]="showZAxis" (change)="toggleAxis('Z')">
              <span class="checkmark"></span>
              <span class="mac-label">{{tempLabelZ || 'Z-Axis'}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Device filter dropdown -->
    <div class="filter-section device-dropdown">
      <button class="dropdown-toggle modern-btn" (click)="toggleDropdown('device')">
        <span>Devices</span>
        <span class="selected-count">{{selectedEquipmentLocation.length}}</span>
        <span class="dropdown-icon" [ngClass]="{'open': isDeviceDropdownOpen}"></span>
      </button>
      <div class="dropdown-menu" [ngClass]="{'show': isDeviceDropdownOpen}">
        <div class="dropdown-header">
          <!-- <h5>Select Devices</h5> -->
          <div class="select-actions">
            <button mat-stroked-button color="primary" (click)="selectAllEquipmentLocation()">Select All</button>
            <button mat-stroked-button color="warn" (click)="clearAllEquipmentLocation()">Deselect All</button>
          </div>
        </div>
        <div class="mac-address-list">
          <div class="mac-item" *ngFor="let mac of availableEquipmentLocation">
            <label class="checkbox-container">
              <input
                type="checkbox"
                [checked]="selectedEquipmentLocation.includes(mac)"
                (change)="toggleMacAddress(mac)"
              >
              <span class="checkmark"></span>
              <span class="mac-label">{{mac}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="chart-wrapper">
    <div class="loading-overlay" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading chart data...</p>
    </div>

    <div class="threshold-legend">
      <div class="threshold-item">
        <span class="color-box normal"></span>
        <span>Healthy (0 - {{green}})</span>
      </div>
      <div class="threshold-item">
        <span class="color-box warning"></span>
        <span>Unsatisfactory ({{green}} - {{yellow}})</span>
      </div>
      <div class="threshold-item">
        <span class="color-box critical"></span>
        <span>Unacceptable ({{yellow}} - {{red}})</span>
      </div>
    </div>

    <div *ngIf="!isLoading && series.length === 0" class="no-data">
      <p>No data available. Please select at least one device and axis type.</p>
    </div>

    <apx-chart
      *ngIf="series.length > 0"
      [series]="series"
      [chart]="chartOptions.chart"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [annotations]="chartOptions.annotations"
      [stroke]="chartOptions.stroke"
      [markers]="chartOptions.markers"
      [tooltip]="chartOptions.tooltip"
      [legend]="chartOptions.legend"
      [grid]="chartOptions.grid"
      [theme]="chartOptions.theme"
      [dataLabels]="chartOptions.dataLabels"
    ></apx-chart>
  </div>
</div>